export default "__VITE_ASSET__BAJVL8RA__"